import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { useAuth } from '../lib/AuthContext.jsx';

// Field rep's own QR code (Dan, 2026-09-21) -- same PLAN_URL + ?rep=<slug>
// pattern as the admin Rep QR Codes page (Reps.jsx), but scoped to the
// logged-in rep and built entirely client-side from their own session
// (user.email/user.name), not a GET /reps call -- reps aren't granted
// that route (see backend/src/routes/reps.js), and don't need the whole
// roster just to get their own code.
//
// PLAN_URL must match pp_checkout_setting('plan_url') in the WordPress
// checkout plugin and Reps.jsx's own copy of this constant -- the three
// aren't wired together, so if that URL ever changes, update all three.
const PLAN_URL = 'https://pricklypearwildlife.com/pest-control-plans/';

function repSlug(email) {
  if (!email) return '';
  return email.split('@')[0].trim().toLowerCase();
}

export default function MyQRCode() {
  const { user } = useAuth();
  const canvasRef = useRef(null);
  const slug = repSlug(user?.email);
  const url = slug ? `${PLAN_URL}?rep=${encodeURIComponent(slug)}` : '';

  function download() {
    const canvas = canvasRef.current?.querySelector('canvas');
    if (!canvas) return;
    const link = document.createElement('a');
    link.download = `prickly-pear-rep-qr-${slug}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  }

  return (
    <div>
      <h2>My QR Code</h2>
      <p className="hint-text">
        Scanning this takes a customer straight to the plan page with your code pre-filled -- any
        subscription they sign up for there gets credited to you automatically. Save it to your
        phone, print it, or add it to a business card or yard sign.
      </p>
      {!slug ? (
        <div className="card" style={{ maxWidth: 320 }}>
          <p className="hint-text" style={{ margin: 0 }}>No email on file -- can't build your code. Ask an admin to check your account.</p>
        </div>
      ) : (
        <div className="card" style={{ maxWidth: 320 }}>
          <h3 style={{ marginTop: 0, marginBottom: 4 }}>{user.name}</h3>
          <p style={{ fontSize: 12, color: 'var(--color-text-muted)', marginTop: 0 }}>{user.email}</p>
          <div ref={canvasRef} style={{ display: 'flex', justifyContent: 'center', margin: '12px 0' }}>
            <QRCodeCanvas value={url} size={220} level="M" includeMargin />
          </div>
          <p style={{ fontSize: 12, wordBreak: 'break-all', color: 'var(--color-text-muted)' }}>{url}</p>
          <button type="button" className="btn btn-primary" onClick={download} style={{ width: '100%' }}>
            Download PNG
          </button>
        </div>
      )}
    </div>
  );
}
